import { render, staticRenderFns } from "./ProfileIcon.vue?vue&type=template&id=9ff30c5e&"
import script from "./ProfileIcon.vue?vue&type=script&lang=ts&"
export * from "./ProfileIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports